import React from "react";

function PriorityListingIcon() {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0H16C22.6274 0 28 5.37258 28 12V16C28 22.6274 22.6274 28 16 28H12C5.37258 28 0 22.6274 0 16V12Z"
        fill="#EAECF0"
      />
      <path
        d="M11.7 6.94531H7.53328C7.07305 6.94531 6.69995 7.31841 6.69995 7.77865V11.9453C6.69995 12.4056 7.07305 12.7786 7.53328 12.7786H11.7C12.1602 12.7786 12.5333 12.4056 12.5333 11.9453V7.77865C12.5333 7.31841 12.1602 6.94531 11.7 6.94531Z"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8667 6.94531H16.7C16.2398 6.94531 15.8667 7.31841 15.8667 7.77865V11.9453C15.8667 12.4056 16.2398 12.7786 16.7 12.7786H20.8667C21.3269 12.7786 21.7 12.4056 21.7 11.9453V7.77865C21.7 7.31841 21.3269 6.94531 20.8667 6.94531Z"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.8667 16.1133H16.7C16.2398 16.1133 15.8667 16.4864 15.8667 16.9466V21.1133C15.8667 21.5735 16.2398 21.9466 16.7 21.9466H20.8667C21.3269 21.9466 21.7 21.5735 21.7 21.1133V16.9466C21.7 16.4864 21.3269 16.1133 20.8667 16.1133Z"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.7 16.1133H7.53328C7.07305 16.1133 6.69995 16.4864 6.69995 16.9466V21.1133C6.69995 21.5735 7.07305 21.9466 7.53328 21.9466H11.7C12.1602 21.9466 12.5333 21.5735 12.5333 21.1133V16.9466C12.5333 16.4864 12.1602 16.1133 11.7 16.1133Z"
        stroke="#424242"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default PriorityListingIcon;
